export const NAME_MAX_LENGTH = {
  form: 255,
  kiosk: 64,
  package: 255,
  product: 255,
  resource: 255,
  service: 255,
  tag: 256
};

export const maxLengthMsg = (field, max) => `${field} must be ${max} characters or fewer`;
